import { ENUM_TYPE_VIDEO } from 'constants/enum';
import SampleVideoList from 'pages/SampleVideo/List/SampleVideo';

const SampleVideoASE = () => {
  return <SampleVideoList type={ENUM_TYPE_VIDEO.ASE} />;
};

export default SampleVideoASE;
